// extracted by mini-css-extract-plugin
export var sidenav = "Sidenav-module--sidenav--68b09";
export var siteBrand__subTitle = "Sidenav-module--site-brand__sub-title--d4c01";
export var siteBrand__title = "Sidenav-module--site-brand__title--64179";